import { v4 as uuidv4 } from "uuid";

export const getDeviceId = () => {
  const existingInfo =
    JSON.parse(localStorage.getItem("bigfoot-otherInfo")) || {};
  if (existingInfo.deviceId) {
    return existingInfo.deviceId;
  }

  // No ID yet – generate a new UUID and store it in the same object
  const deviceId = uuidv4();
  try {
    existingInfo.deviceId = deviceId;
    localStorage.setItem("bigfoot-otherInfo", JSON.stringify(existingInfo));
  } catch (e) {
    console.warn("Unable to persist deviceId in bigfoot-otherInfo:", e);
  }
  return deviceId;
};
